import { useEffect, useState } from 'react';

import { getSummaryService, SummaryResponse } from '../api/getSummary';
import useArnFromPath from './useArnFromPath';
import useSettings from './useSettings';

const useGetApplicationSummary = (): SummaryResponse | undefined => {
    const { apiKey, proxyBaseUrl } = useSettings();
    const applicationReferenceNumber = useArnFromPath();

    const [summary, setSummary] = useState<SummaryResponse>();

    useEffect(() => {
        if (!applicationReferenceNumber) {
            return;
        }
        getSummaryService(proxyBaseUrl, apiKey, applicationReferenceNumber)
            .then((data) => {
                setSummary(data);
            })
            .catch(() => {
                setSummary(undefined);
            });
    }, [proxyBaseUrl]);

    return summary;
};
export default useGetApplicationSummary;
